// extracted by mini-css-extract-plugin
export default {"cartItemDetails":"cartItemDetails__Mzg2Z","smaller":"smaller__ZTE1Z"};